import { render, staticRenderFns } from "./auth-group-detail.vue?vue&type=template&id=5a3abe7d"
import script from "./auth-group-detail.vue?vue&type=script&lang=js"
export * from "./auth-group-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports